var map = {
	"./": "./src/assets/img/index.js",
	"./10ft_circle-fill2.png": "./src/assets/img/10ft_circle-fill2.png",
	"./10ft_circle-line.png": "./src/assets/img/10ft_circle-line.png",
	"./10ft_circle_line.png": "./src/assets/img/10ft_circle_line.png",
	"./10x10-rubber.png": "./src/assets/img/10x10-rubber.png",
	"./12x12-0.png": "./src/assets/img/12x12-0.png",
	"./12x12-1.png": "./src/assets/img/12x12-1.png",
	"./12x12-10.png": "./src/assets/img/12x12-10.png",
	"./12x12-11.png": "./src/assets/img/12x12-11.png",
	"./12x12-12.png": "./src/assets/img/12x12-12.png",
	"./12x12-13.png": "./src/assets/img/12x12-13.png",
	"./12x12-14.png": "./src/assets/img/12x12-14.png",
	"./12x12-15.png": "./src/assets/img/12x12-15.png",
	"./12x12-16.png": "./src/assets/img/12x12-16.png",
	"./12x12-2.png": "./src/assets/img/12x12-2.png",
	"./12x12-3.png": "./src/assets/img/12x12-3.png",
	"./12x12-4.png": "./src/assets/img/12x12-4.png",
	"./12x12-5.png": "./src/assets/img/12x12-5.png",
	"./12x12-6.png": "./src/assets/img/12x12-6.png",
	"./12x12-7.png": "./src/assets/img/12x12-7.png",
	"./12x12-8.png": "./src/assets/img/12x12-8.png",
	"./12x12-9.png": "./src/assets/img/12x12-9.png",
	"./12x12.png": "./src/assets/img/12x12.png",
	"./1x1.png": "./src/assets/img/1x1.png",
	"./1x3.png": "./src/assets/img/1x3.png",
	"./28ft_circle.png": "./src/assets/img/28ft_circle.png",
	"./28ft_circle_solid.png": "./src/assets/img/28ft_circle_solid.png",
	"./2x3.png": "./src/assets/img/2x3.png",
	"./30_circle-line.png": "./src/assets/img/30_circle-line.png",
	"./30ft_circle-line2.png": "./src/assets/img/30ft_circle-line2.png",
	"./30ft_circle-line_3.png": "./src/assets/img/30ft_circle-line_3.png",
	"./30ft_circle_line3.png": "./src/assets/img/30ft_circle_line3.png",
	"./30ft_circle_solid.png": "./src/assets/img/30ft_circle_solid.png",
	"./30x30-0.png": "./src/assets/img/30x30-0.png",
	"./30x30-1.png": "./src/assets/img/30x30-1.png",
	"./30x30-10.png": "./src/assets/img/30x30-10.png",
	"./30x30-11.png": "./src/assets/img/30x30-11.png",
	"./30x30-12.png": "./src/assets/img/30x30-12.png",
	"./30x30-13.png": "./src/assets/img/30x30-13.png",
	"./30x30-14.png": "./src/assets/img/30x30-14.png",
	"./30x30-15.png": "./src/assets/img/30x30-15.png",
	"./30x30-16.png": "./src/assets/img/30x30-16.png",
	"./30x30-2.png": "./src/assets/img/30x30-2.png",
	"./30x30-3.png": "./src/assets/img/30x30-3.png",
	"./30x30-4.png": "./src/assets/img/30x30-4.png",
	"./30x30-5.png": "./src/assets/img/30x30-5.png",
	"./30x30-6.png": "./src/assets/img/30x30-6.png",
	"./30x30-7.png": "./src/assets/img/30x30-7.png",
	"./30x30-8.png": "./src/assets/img/30x30-8.png",
	"./30x30-9.png": "./src/assets/img/30x30-9.png",
	"./30x30.png": "./src/assets/img/30x30.png",
	"./32ft_circle.png": "./src/assets/img/32ft_circle.png",
	"./32ft_circle_solid.png": "./src/assets/img/32ft_circle_solid.png",
	"./36x36-0.png": "./src/assets/img/36x36-0.png",
	"./36x36-1.png": "./src/assets/img/36x36-1.png",
	"./36x36-10.png": "./src/assets/img/36x36-10.png",
	"./36x36-11.png": "./src/assets/img/36x36-11.png",
	"./36x36-12.png": "./src/assets/img/36x36-12.png",
	"./36x36-13.png": "./src/assets/img/36x36-13.png",
	"./36x36-14.png": "./src/assets/img/36x36-14.png",
	"./36x36-15.png": "./src/assets/img/36x36-15.png",
	"./36x36-16.png": "./src/assets/img/36x36-16.png",
	"./36x36-2.png": "./src/assets/img/36x36-2.png",
	"./36x36-3.png": "./src/assets/img/36x36-3.png",
	"./36x36-4.png": "./src/assets/img/36x36-4.png",
	"./36x36-5.png": "./src/assets/img/36x36-5.png",
	"./36x36-6.png": "./src/assets/img/36x36-6.png",
	"./36x36-7.png": "./src/assets/img/36x36-7.png",
	"./36x36-8.png": "./src/assets/img/36x36-8.png",
	"./36x36-9.png": "./src/assets/img/36x36-9.png",
	"./36x36.png": "./src/assets/img/36x36.png",
	"./3x1.png": "./src/assets/img/3x1.png",
	"./3x2.png": "./src/assets/img/3x2.png",
	"./3x3.png": "./src/assets/img/3x3.png",
	"./40x40-0.png": "./src/assets/img/40x40-0.png",
	"./40x40-1.png": "./src/assets/img/40x40-1.png",
	"./40x40-10.png": "./src/assets/img/40x40-10.png",
	"./40x40-11.png": "./src/assets/img/40x40-11.png",
	"./40x40-12.png": "./src/assets/img/40x40-12.png",
	"./40x40-13.png": "./src/assets/img/40x40-13.png",
	"./40x40-14.png": "./src/assets/img/40x40-14.png",
	"./40x40-15.png": "./src/assets/img/40x40-15.png",
	"./40x40-16.png": "./src/assets/img/40x40-16.png",
	"./40x40-2.png": "./src/assets/img/40x40-2.png",
	"./40x40-3.png": "./src/assets/img/40x40-3.png",
	"./40x40-4.png": "./src/assets/img/40x40-4.png",
	"./40x40-5.png": "./src/assets/img/40x40-5.png",
	"./40x40-6.png": "./src/assets/img/40x40-6.png",
	"./40x40-7.png": "./src/assets/img/40x40-7.png",
	"./40x40-8.png": "./src/assets/img/40x40-8.png",
	"./40x40-9.png": "./src/assets/img/40x40-9.png",
	"./40x40.png": "./src/assets/img/40x40.png",
	"./42x38-0.png": "./src/assets/img/42x38-0.png",
	"./42x38-1.png": "./src/assets/img/42x38-1.png",
	"./42x38-10.png": "./src/assets/img/42x38-10.png",
	"./42x38-11.png": "./src/assets/img/42x38-11.png",
	"./42x38-12.png": "./src/assets/img/42x38-12.png",
	"./42x38-13.png": "./src/assets/img/42x38-13.png",
	"./42x38-14.png": "./src/assets/img/42x38-14.png",
	"./42x38-15.png": "./src/assets/img/42x38-15.png",
	"./42x38-16.png": "./src/assets/img/42x38-16.png",
	"./42x38-2.png": "./src/assets/img/42x38-2.png",
	"./42x38-3.png": "./src/assets/img/42x38-3.png",
	"./42x38-4.png": "./src/assets/img/42x38-4.png",
	"./42x38-5.png": "./src/assets/img/42x38-5.png",
	"./42x38-6.png": "./src/assets/img/42x38-6.png",
	"./42x38-7.png": "./src/assets/img/42x38-7.png",
	"./42x38-8.png": "./src/assets/img/42x38-8.png",
	"./42x38-9.png": "./src/assets/img/42x38-9.png",
	"./42x38.png": "./src/assets/img/42x38.png",
	"./42x40-0.png": "./src/assets/img/42x40-0.png",
	"./42x40-1.png": "./src/assets/img/42x40-1.png",
	"./42x40-10.png": "./src/assets/img/42x40-10.png",
	"./42x40-11.png": "./src/assets/img/42x40-11.png",
	"./42x40-12.png": "./src/assets/img/42x40-12.png",
	"./42x40-13.png": "./src/assets/img/42x40-13.png",
	"./42x40-14.png": "./src/assets/img/42x40-14.png",
	"./42x40-15.png": "./src/assets/img/42x40-15.png",
	"./42x40-16.png": "./src/assets/img/42x40-16.png",
	"./42x40-2.png": "./src/assets/img/42x40-2.png",
	"./42x40-3.png": "./src/assets/img/42x40-3.png",
	"./42x40-4.png": "./src/assets/img/42x40-4.png",
	"./42x40-5.png": "./src/assets/img/42x40-5.png",
	"./42x40-6.png": "./src/assets/img/42x40-6.png",
	"./42x40-7.png": "./src/assets/img/42x40-7.png",
	"./42x40-8.png": "./src/assets/img/42x40-8.png",
	"./42x40-9.png": "./src/assets/img/42x40-9.png",
	"./42x40.png": "./src/assets/img/42x40.png",
	"./42x42-0.png": "./src/assets/img/42x42-0.png",
	"./42x42-1.png": "./src/assets/img/42x42-1.png",
	"./42x42-10.png": "./src/assets/img/42x42-10.png",
	"./42x42-11.png": "./src/assets/img/42x42-11.png",
	"./42x42-12.png": "./src/assets/img/42x42-12.png",
	"./42x42-13.png": "./src/assets/img/42x42-13.png",
	"./42x42-14.png": "./src/assets/img/42x42-14.png",
	"./42x42-15.png": "./src/assets/img/42x42-15.png",
	"./42x42-16.png": "./src/assets/img/42x42-16.png",
	"./42x42-2.png": "./src/assets/img/42x42-2.png",
	"./42x42-3.png": "./src/assets/img/42x42-3.png",
	"./42x42-4.png": "./src/assets/img/42x42-4.png",
	"./42x42-5.png": "./src/assets/img/42x42-5.png",
	"./42x42-6.png": "./src/assets/img/42x42-6.png",
	"./42x42-7.png": "./src/assets/img/42x42-7.png",
	"./42x42-8.png": "./src/assets/img/42x42-8.png",
	"./42x42-9.png": "./src/assets/img/42x42-9.png",
	"./42x42.png": "./src/assets/img/42x42.png",
	"./5x5-rubber.png": "./src/assets/img/5x5-rubber.png",
	"./7x7-rubber.png": "./src/assets/img/7x7-rubber.png",
	"./9x9-rubber.png": "./src/assets/img/9x9-rubber.png",
	"./Black.png": "./src/assets/img/Black.png",
	"./BlackTatami.png": "./src/assets/img/BlackTatami.png",
	"./CharcoalGray.png": "./src/assets/img/CharcoalGray.png",
	"./CharcoalGrey.png": "./src/assets/img/CharcoalGrey.png",
	"./Red.png": "./src/assets/img/Red.png",
	"./RoyalBlue.png": "./src/assets/img/RoyalBlue.png",
	"./Royal_Blue.png": "./src/assets/img/Royal_Blue.png",
	"./WoodGrain.png": "./src/assets/img/WoodGrain.png",
	"./Wood_Grain.png": "./src/assets/img/Wood_Grain.png",
	"./add-artwork-menu.png": "./src/assets/img/add-artwork-menu.png",
	"./add-circle-center-img.jpg": "./src/assets/img/add-circle-center-img.jpg",
	"./add-circle-icon.png": "./src/assets/img/add-circle-icon.png",
	"./addlogo.png": "./src/assets/img/addlogo.png",
	"./addlogobg.png": "./src/assets/img/addlogobg.png",
	"./addtext.png": "./src/assets/img/addtext.png",
	"./adlogo.jpg": "./src/assets/img/adlogo.jpg",
	"./angle-left.png": "./src/assets/img/angle-left.png",
	"./angle-right.png": "./src/assets/img/angle-right.png",
	"./art-clip1.png": "./src/assets/img/art-clip1.png",
	"./art-clip2.png": "./src/assets/img/art-clip2.png",
	"./art-clip3.png": "./src/assets/img/art-clip3.png",
	"./art-clip4.png": "./src/assets/img/art-clip4.png",
	"./art-clip5.png": "./src/assets/img/art-clip5.png",
	"./art-clip6.png": "./src/assets/img/art-clip6.png",
	"./art-clip7.png": "./src/assets/img/art-clip7.png",
	"./art-clip8.png": "./src/assets/img/art-clip8.png",
	"./artwork.jpg": "./src/assets/img/artwork.jpg",
	"./artwork.png": "./src/assets/img/artwork.png",
	"./background1.png": "./src/assets/img/background1.png",
	"./background2.png": "./src/assets/img/background2.png",
	"./backgroundSawain.png": "./src/assets/img/backgroundSawain.png",
	"./bg.png": "./src/assets/img/bg.png",
	"./bgnew.jpg": "./src/assets/img/bgnew.jpg",
	"./bkarw.png": "./src/assets/img/bkarw.png",
	"./black1.jpg": "./src/assets/img/black1.jpg",
	"./black2.jpg": "./src/assets/img/black2.jpg",
	"./black3.jpg": "./src/assets/img/black3.jpg",
	"./black_1.jpg": "./src/assets/img/black_1.jpg",
	"./black_1.png": "./src/assets/img/black_1.png",
	"./black_2.jpg": "./src/assets/img/black_2.jpg",
	"./black_3.jpg": "./src/assets/img/black_3.jpg",
	"./blue_1.jpg": "./src/assets/img/blue_1.jpg",
	"./blue_2.jpg": "./src/assets/img/blue_2.jpg",
	"./blue_3.jpg": "./src/assets/img/blue_3.jpg",
	"./center-align.png": "./src/assets/img/center-align.png",
	"./circle.png": "./src/assets/img/circle.png",
	"./circle1.jpg": "./src/assets/img/circle1.jpg",
	"./circle2.jpg": "./src/assets/img/circle2.jpg",
	"./circle3.jpg": "./src/assets/img/circle3.jpg",
	"./circle4.jpg": "./src/assets/img/circle4.jpg",
	"./circle_30_solid2.png": "./src/assets/img/circle_30_solid2.png",
	"./circles.png": "./src/assets/img/circles.png",
	"./circles10-01.png": "./src/assets/img/circles10-01.png",
	"./clip-middle-img.jpg": "./src/assets/img/clip-middle-img.jpg",
	"./color.png": "./src/assets/img/color.png",
	"./cross.png": "./src/assets/img/cross.png",
	"./custom-colr-sllide.png": "./src/assets/img/custom-colr-sllide.png",
	"./custom-colr.jpg": "./src/assets/img/custom-colr.jpg",
	"./custom-colr.png": "./src/assets/img/custom-colr.png",
	"./del.png": "./src/assets/img/del.png",
	"./delbk.png": "./src/assets/img/delbk.png",
	"./delbk2.png": "./src/assets/img/delbk2.png",
	"./delete.png": "./src/assets/img/delete.png",
	"./design-text-view.jpg": "./src/assets/img/design-text-view.jpg",
	"./doubleFive.png": "./src/assets/img/doubleFive.png",
	"./doubleStairs.png": "./src/assets/img/doubleStairs.png",
	"./download.png": "./src/assets/img/download.png",
	"./duplicate.png": "./src/assets/img/duplicate.png",
	"./email.png": "./src/assets/img/email.png",
	"./expand.png": "./src/assets/img/expand.png",
	"./flexi_mb.png": "./src/assets/img/flexi_mb.png",
	"./flexi_pc.png": "./src/assets/img/flexi_pc.png",
	"./fwarw.png": "./src/assets/img/fwarw.png",
	"./gold1.jpg": "./src/assets/img/gold1.jpg",
	"./gold2.jpg": "./src/assets/img/gold2.jpg",
	"./gold3.jpg": "./src/assets/img/gold3.jpg",
	"./gold_1.jpg": "./src/assets/img/gold_1.jpg",
	"./gold_2.jpg": "./src/assets/img/gold_2.jpg",
	"./gold_3.jpg": "./src/assets/img/gold_3.jpg",
	"./gqimg.png": "./src/assets/img/gqimg.png",
	"./gray_1.jpg": "./src/assets/img/gray_1.jpg",
	"./gray_2.jpg": "./src/assets/img/gray_2.jpg",
	"./gray_3.jpg": "./src/assets/img/gray_3.jpg",
	"./green.jpg": "./src/assets/img/green.jpg",
	"./green2.jpg": "./src/assets/img/green2.jpg",
	"./green3.jpg": "./src/assets/img/green3.jpg",
	"./grey1.jpg": "./src/assets/img/grey1.jpg",
	"./grey2.jpg": "./src/assets/img/grey2.jpg",
	"./grey3.jpg": "./src/assets/img/grey3.jpg",
	"./home_background.png": "./src/assets/img/home_background.png",
	"./home_mb.png": "./src/assets/img/home_mb.png",
	"./icon-collapse.png": "./src/assets/img/icon-collapse.png",
	"./index": "./src/assets/img/index.js",
	"./index.js": "./src/assets/img/index.js",
	"./info.png": "./src/assets/img/info.png",
	"./left-align.png": "./src/assets/img/left-align.png",
	"./lightgreen_1.jpg": "./src/assets/img/lightgreen_1.jpg",
	"./lightgreen_2.jpg": "./src/assets/img/lightgreen_2.jpg",
	"./lightgreen_3.jpg": "./src/assets/img/lightgreen_3.jpg",
	"./lineimg.png": "./src/assets/img/lineimg.png",
	"./logo-new.png": "./src/assets/img/logo-new.png",
	"./logo.jpg": "./src/assets/img/logo.jpg",
	"./logo.png": "./src/assets/img/logo.png",
	"./mailbk.png": "./src/assets/img/mailbk.png",
	"./mat-desing.jpg": "./src/assets/img/mat-desing.jpg",
	"./matbg.jpg": "./src/assets/img/matbg.jpg",
	"./mats.png": "./src/assets/img/mats.png",
	"./menu.png": "./src/assets/img/menu.png",
	"./moblogo.png": "./src/assets/img/moblogo.png",
	"./oct24-0.png": "./src/assets/img/oct24-0.png",
	"./oct24-1.png": "./src/assets/img/oct24-1.png",
	"./oct24-10.png": "./src/assets/img/oct24-10.png",
	"./oct24-11.png": "./src/assets/img/oct24-11.png",
	"./oct24-12.png": "./src/assets/img/oct24-12.png",
	"./oct24-13.png": "./src/assets/img/oct24-13.png",
	"./oct24-14.png": "./src/assets/img/oct24-14.png",
	"./oct24-15.png": "./src/assets/img/oct24-15.png",
	"./oct24-16.png": "./src/assets/img/oct24-16.png",
	"./oct24-2.png": "./src/assets/img/oct24-2.png",
	"./oct24-3.png": "./src/assets/img/oct24-3.png",
	"./oct24-4.png": "./src/assets/img/oct24-4.png",
	"./oct24-5.png": "./src/assets/img/oct24-5.png",
	"./oct24-6.png": "./src/assets/img/oct24-6.png",
	"./oct24-7.png": "./src/assets/img/oct24-7.png",
	"./oct24-8.png": "./src/assets/img/oct24-8.png",
	"./oct24-9.png": "./src/assets/img/oct24-9.png",
	"./oct24.png": "./src/assets/img/oct24.png",
	"./oct30-0.png": "./src/assets/img/oct30-0.png",
	"./oct30-1.png": "./src/assets/img/oct30-1.png",
	"./oct30-10.png": "./src/assets/img/oct30-10.png",
	"./oct30-11.png": "./src/assets/img/oct30-11.png",
	"./oct30-12.png": "./src/assets/img/oct30-12.png",
	"./oct30-13.png": "./src/assets/img/oct30-13.png",
	"./oct30-14.png": "./src/assets/img/oct30-14.png",
	"./oct30-15.png": "./src/assets/img/oct30-15.png",
	"./oct30-16.png": "./src/assets/img/oct30-16.png",
	"./oct30-2.png": "./src/assets/img/oct30-2.png",
	"./oct30-3.png": "./src/assets/img/oct30-3.png",
	"./oct30-4.png": "./src/assets/img/oct30-4.png",
	"./oct30-5.png": "./src/assets/img/oct30-5.png",
	"./oct30-6.png": "./src/assets/img/oct30-6.png",
	"./oct30-7.png": "./src/assets/img/oct30-7.png",
	"./oct30-8.png": "./src/assets/img/oct30-8.png",
	"./oct30-9.png": "./src/assets/img/oct30-9.png",
	"./oct30.png": "./src/assets/img/oct30.png",
	"./pimg.jpg": "./src/assets/img/pimg.jpg",
	"./preview.png": "./src/assets/img/preview.png",
	"./profile.jpg": "./src/assets/img/profile.jpg",
	"./puzzle_mb.jpg": "./src/assets/img/puzzle_mb.jpg",
	"./puzzle_pc.jpg": "./src/assets/img/puzzle_pc.jpg",
	"./quote.png": "./src/assets/img/quote.png",
	"./rb1.jpg": "./src/assets/img/rb1.jpg",
	"./rb2.jpg": "./src/assets/img/rb2.jpg",
	"./rb3.jpg": "./src/assets/img/rb3.jpg",
	"./rectangles.png": "./src/assets/img/rectangles.png",
	"./red1.jpg": "./src/assets/img/red1.jpg",
	"./red2.jpg": "./src/assets/img/red2.jpg",
	"./red3.jpg": "./src/assets/img/red3.jpg",
	"./red_1.jpg": "./src/assets/img/red_1.jpg",
	"./red_2.jpg": "./src/assets/img/red_2.jpg",
	"./red_3.jpg": "./src/assets/img/red_3.jpg",
	"./redo.png": "./src/assets/img/redo.png",
	"./redobk.png": "./src/assets/img/redobk.png",
	"./right-align.png": "./src/assets/img/right-align.png",
	"./rosewood.png": "./src/assets/img/rosewood.png",
	"./rotation_left.png": "./src/assets/img/rotation_left.png",
	"./rotation_right.png": "./src/assets/img/rotation_right.png",
	"./rubberPuzzle/centerMatBlack10.png": "./src/assets/img/rubberPuzzle/centerMatBlack10.png",
	"./rubberPuzzle/centerMatBlue10.png": "./src/assets/img/rubberPuzzle/centerMatBlue10.png",
	"./rubberPuzzle/centerMatBlue35.png": "./src/assets/img/rubberPuzzle/centerMatBlue35.png",
	"./rubberPuzzle/centerMatBrick10.png": "./src/assets/img/rubberPuzzle/centerMatBrick10.png",
	"./rubberPuzzle/centerMatBrown95.png": "./src/assets/img/rubberPuzzle/centerMatBrown95.png",
	"./rubberPuzzle/centerMatCharcoalGery95.png": "./src/assets/img/rubberPuzzle/centerMatCharcoalGery95.png",
	"./rubberPuzzle/centerMatGery10.png": "./src/assets/img/rubberPuzzle/centerMatGery10.png",
	"./rubberPuzzle/centerMatGery35.png": "./src/assets/img/rubberPuzzle/centerMatGery35.png",
	"./rubberPuzzle/centerMatGreen35.png": "./src/assets/img/rubberPuzzle/centerMatGreen35.png",
	"./rubberPuzzle/centerMatGrey95.png": "./src/assets/img/rubberPuzzle/centerMatGrey95.png",
	"./rubberPuzzle/centerMatGreyTan95.png": "./src/assets/img/rubberPuzzle/centerMatGreyTan95.png",
	"./rubberPuzzle/centerMatRed35.png": "./src/assets/img/rubberPuzzle/centerMatRed35.png",
	"./rubberPuzzle/centerMatRed95.png": "./src/assets/img/rubberPuzzle/centerMatRed95.png",
	"./rubberPuzzle/centerMatTan10.png": "./src/assets/img/rubberPuzzle/centerMatTan10.png",
	"./rubberPuzzle/centerMatTan35.png": "./src/assets/img/rubberPuzzle/centerMatTan35.png",
	"./rubberPuzzle/centerMatTan95.png": "./src/assets/img/rubberPuzzle/centerMatTan95.png",
	"./rubberPuzzle/centerMat_0.png": "./src/assets/img/rubberPuzzle/centerMat_0.png",
	"./rubberPuzzle/centreMatBlack10.png": "./src/assets/img/rubberPuzzle/centreMatBlack10.png",
	"./rubberPuzzle/cornerMatBlack10.png": "./src/assets/img/rubberPuzzle/cornerMatBlack10.png",
	"./rubberPuzzle/cornerMatBlue10.png": "./src/assets/img/rubberPuzzle/cornerMatBlue10.png",
	"./rubberPuzzle/cornerMatBlue35.png": "./src/assets/img/rubberPuzzle/cornerMatBlue35.png",
	"./rubberPuzzle/cornerMatBrick10.png": "./src/assets/img/rubberPuzzle/cornerMatBrick10.png",
	"./rubberPuzzle/cornerMatBrown95.png": "./src/assets/img/rubberPuzzle/cornerMatBrown95.png",
	"./rubberPuzzle/cornerMatCharcoalGery95.png": "./src/assets/img/rubberPuzzle/cornerMatCharcoalGery95.png",
	"./rubberPuzzle/cornerMatGery10.png": "./src/assets/img/rubberPuzzle/cornerMatGery10.png",
	"./rubberPuzzle/cornerMatGery35.png": "./src/assets/img/rubberPuzzle/cornerMatGery35.png",
	"./rubberPuzzle/cornerMatGery95.png": "./src/assets/img/rubberPuzzle/cornerMatGery95.png",
	"./rubberPuzzle/cornerMatGeryTan95.png": "./src/assets/img/rubberPuzzle/cornerMatGeryTan95.png",
	"./rubberPuzzle/cornerMatGreen35.png": "./src/assets/img/rubberPuzzle/cornerMatGreen35.png",
	"./rubberPuzzle/cornerMatRed35.png": "./src/assets/img/rubberPuzzle/cornerMatRed35.png",
	"./rubberPuzzle/cornerMatRed95.png": "./src/assets/img/rubberPuzzle/cornerMatRed95.png",
	"./rubberPuzzle/cornerMatTan10.png": "./src/assets/img/rubberPuzzle/cornerMatTan10.png",
	"./rubberPuzzle/cornerMatTan35.png": "./src/assets/img/rubberPuzzle/cornerMatTan35.png",
	"./rubberPuzzle/cornerMatTan95.png": "./src/assets/img/rubberPuzzle/cornerMatTan95.png",
	"./rubberPuzzle/cornerMat_0.png": "./src/assets/img/rubberPuzzle/cornerMat_0.png",
	"./rubberPuzzle/sideMatBlack10.png": "./src/assets/img/rubberPuzzle/sideMatBlack10.png",
	"./rubberPuzzle/sideMatBlue10.png": "./src/assets/img/rubberPuzzle/sideMatBlue10.png",
	"./rubberPuzzle/sideMatBlue35.png": "./src/assets/img/rubberPuzzle/sideMatBlue35.png",
	"./rubberPuzzle/sideMatBrick10.png": "./src/assets/img/rubberPuzzle/sideMatBrick10.png",
	"./rubberPuzzle/sideMatBrown95.png": "./src/assets/img/rubberPuzzle/sideMatBrown95.png",
	"./rubberPuzzle/sideMatCharcoalGrey95.png": "./src/assets/img/rubberPuzzle/sideMatCharcoalGrey95.png",
	"./rubberPuzzle/sideMatGery10.png": "./src/assets/img/rubberPuzzle/sideMatGery10.png",
	"./rubberPuzzle/sideMatGery35.png": "./src/assets/img/rubberPuzzle/sideMatGery35.png",
	"./rubberPuzzle/sideMatGreen35.png": "./src/assets/img/rubberPuzzle/sideMatGreen35.png",
	"./rubberPuzzle/sideMatGrey95.png": "./src/assets/img/rubberPuzzle/sideMatGrey95.png",
	"./rubberPuzzle/sideMatGreyTan95.png": "./src/assets/img/rubberPuzzle/sideMatGreyTan95.png",
	"./rubberPuzzle/sideMatRed35.png": "./src/assets/img/rubberPuzzle/sideMatRed35.png",
	"./rubberPuzzle/sideMatRed95.png": "./src/assets/img/rubberPuzzle/sideMatRed95.png",
	"./rubberPuzzle/sideMatTan10.png": "./src/assets/img/rubberPuzzle/sideMatTan10.png",
	"./rubberPuzzle/sideMatTan35.png": "./src/assets/img/rubberPuzzle/sideMatTan35.png",
	"./rubberPuzzle/sideMatTan95.png": "./src/assets/img/rubberPuzzle/sideMatTan95.png",
	"./rubberPuzzle/sideMat_0.png": "./src/assets/img/rubberPuzzle/sideMat_0.png",
	"./rubberPuzzle/squareMatBlack10.png": "./src/assets/img/rubberPuzzle/squareMatBlack10.png",
	"./rubberPuzzle/squareMatBlue10.png": "./src/assets/img/rubberPuzzle/squareMatBlue10.png",
	"./rubberPuzzle/squareMatBlue35.png": "./src/assets/img/rubberPuzzle/squareMatBlue35.png",
	"./rubberPuzzle/squareMatBrick10.png": "./src/assets/img/rubberPuzzle/squareMatBrick10.png",
	"./rubberPuzzle/squareMatBrick35.png": "./src/assets/img/rubberPuzzle/squareMatBrick35.png",
	"./rubberPuzzle/squareMatBrown95.png": "./src/assets/img/rubberPuzzle/squareMatBrown95.png",
	"./rubberPuzzle/squareMatCharcoalGery95.png": "./src/assets/img/rubberPuzzle/squareMatCharcoalGery95.png",
	"./rubberPuzzle/squareMatGreen35.png": "./src/assets/img/rubberPuzzle/squareMatGreen35.png",
	"./rubberPuzzle/squareMatGrey10.png": "./src/assets/img/rubberPuzzle/squareMatGrey10.png",
	"./rubberPuzzle/squareMatGrey35.png": "./src/assets/img/rubberPuzzle/squareMatGrey35.png",
	"./rubberPuzzle/squareMatGrey95.png": "./src/assets/img/rubberPuzzle/squareMatGrey95.png",
	"./rubberPuzzle/squareMatGreyTan95.png": "./src/assets/img/rubberPuzzle/squareMatGreyTan95.png",
	"./rubberPuzzle/squareMatRed95.png": "./src/assets/img/rubberPuzzle/squareMatRed95.png",
	"./rubberPuzzle/squareMatTan10.png": "./src/assets/img/rubberPuzzle/squareMatTan10.png",
	"./rubberPuzzle/squareMatTan35.png": "./src/assets/img/rubberPuzzle/squareMatTan35.png",
	"./rubberPuzzle/squareMatTan95.png": "./src/assets/img/rubberPuzzle/squareMatTan95.png",
	"./rubberPuzzle/squareMat_0.png": "./src/assets/img/rubberPuzzle/squareMat_0.png",
	"./rubbercolors": "./src/assets/img/rubbercolors/index.js",
	"./rubbercolors/": "./src/assets/img/rubbercolors/index.js",
	"./rubbercolors/GREEN35.jpeg": "./src/assets/img/rubbercolors/GREEN35.jpeg",
	"./rubbercolors/GREY35.jpeg": "./src/assets/img/rubbercolors/GREY35.jpeg",
	"./rubbercolors/RED35.jpeg": "./src/assets/img/rubbercolors/RED35.jpeg",
	"./rubbercolors/TAN35.jpeg": "./src/assets/img/rubbercolors/TAN35.jpeg",
	"./rubbercolors/black10.png": "./src/assets/img/rubbercolors/black10.png",
	"./rubbercolors/blacks10.png": "./src/assets/img/rubbercolors/blacks10.png",
	"./rubbercolors/blue-grey-s-10.png": "./src/assets/img/rubbercolors/blue-grey-s-10.png",
	"./rubbercolors/blue-grey10.png": "./src/assets/img/rubbercolors/blue-grey10.png",
	"./rubbercolors/blue-s-35.png": "./src/assets/img/rubbercolors/blue-s-35.png",
	"./rubbercolors/blue-small-10.png": "./src/assets/img/rubbercolors/blue-small-10.png",
	"./rubbercolors/blue-white-gery-s-20.png": "./src/assets/img/rubbercolors/blue-white-gery-s-20.png",
	"./rubbercolors/blue10.png": "./src/assets/img/rubbercolors/blue10.png",
	"./rubbercolors/blue20.png": "./src/assets/img/rubbercolors/blue20.png",
	"./rubbercolors/blue35.png": "./src/assets/img/rubbercolors/blue35.png",
	"./rubbercolors/blues20.png": "./src/assets/img/rubbercolors/blues20.png",
	"./rubbercolors/brick-s-10.png": "./src/assets/img/rubbercolors/brick-s-10.png",
	"./rubbercolors/brick10.png": "./src/assets/img/rubbercolors/brick10.png",
	"./rubbercolors/brown-95.jpg": "./src/assets/img/rubbercolors/brown-95.jpg",
	"./rubbercolors/brown-s-20.png": "./src/assets/img/rubbercolors/brown-s-20.png",
	"./rubbercolors/brown20.png": "./src/assets/img/rubbercolors/brown20.png",
	"./rubbercolors/charcoal-gery-95.jpg": "./src/assets/img/rubbercolors/charcoal-gery-95.jpg",
	"./rubbercolors/gery-95.jpg": "./src/assets/img/rubbercolors/gery-95.jpg",
	"./rubbercolors/gery-s-35.png": "./src/assets/img/rubbercolors/gery-s-35.png",
	"./rubbercolors/gery-tan-95.jpg": "./src/assets/img/rubbercolors/gery-tan-95.jpg",
	"./rubbercolors/gery-white-blue-20.png": "./src/assets/img/rubbercolors/gery-white-blue-20.png",
	"./rubbercolors/gold-s-20.png": "./src/assets/img/rubbercolors/gold-s-20.png",
	"./rubbercolors/gold20.png": "./src/assets/img/rubbercolors/gold20.png",
	"./rubbercolors/green-s-10.png": "./src/assets/img/rubbercolors/green-s-10.png",
	"./rubbercolors/green-s-35.png": "./src/assets/img/rubbercolors/green-s-35.png",
	"./rubbercolors/green10.png": "./src/assets/img/rubbercolors/green10.png",
	"./rubbercolors/grey-s-10.png": "./src/assets/img/rubbercolors/grey-s-10.png",
	"./rubbercolors/grey-s-20.png": "./src/assets/img/rubbercolors/grey-s-20.png",
	"./rubbercolors/grey10.png": "./src/assets/img/rubbercolors/grey10.png",
	"./rubbercolors/grey20.png": "./src/assets/img/rubbercolors/grey20.png",
	"./rubbercolors/index": "./src/assets/img/rubbercolors/index.js",
	"./rubbercolors/index.js": "./src/assets/img/rubbercolors/index.js",
	"./rubbercolors/purple-10.png": "./src/assets/img/rubbercolors/purple-10.png",
	"./rubbercolors/purple-s-10.png": "./src/assets/img/rubbercolors/purple-s-10.png",
	"./rubbercolors/purple10.png": "./src/assets/img/rubbercolors/purple10.png",
	"./rubbercolors/red-95.jpg": "./src/assets/img/rubbercolors/red-95.jpg",
	"./rubbercolors/red-s-20.png": "./src/assets/img/rubbercolors/red-s-20.png",
	"./rubbercolors/red-s-35.png": "./src/assets/img/rubbercolors/red-s-35.png",
	"./rubbercolors/red20.png": "./src/assets/img/rubbercolors/red20.png",
	"./rubbercolors/tan-95.jpg": "./src/assets/img/rubbercolors/tan-95.jpg",
	"./rubbercolors/tan-s-10.png": "./src/assets/img/rubbercolors/tan-s-10.png",
	"./rubbercolors/tan-s-35.png": "./src/assets/img/rubbercolors/tan-s-35.png",
	"./rubbercolors/tan10.png": "./src/assets/img/rubbercolors/tan10.png",
	"./rubbercolors/white-s-20.png": "./src/assets/img/rubbercolors/white-s-20.png",
	"./rubbercolors/white20.png": "./src/assets/img/rubbercolors/white20.png",
	"./rubbercolors/yellow-s-10.png": "./src/assets/img/rubbercolors/yellow-s-10.png",
	"./rubbercolors/yellow10.png": "./src/assets/img/rubbercolors/yellow10.png",
	"./sandalwood.png": "./src/assets/img/sandalwood.png",
	"./save.png": "./src/assets/img/save.png",
	"./savebk.png": "./src/assets/img/savebk.png",
	"./select-tem.jpg": "./src/assets/img/select-tem.jpg",
	"./share.png": "./src/assets/img/share.png",
	"./singleFive.png": "./src/assets/img/singleFive.png",
	"./singleStairs.png": "./src/assets/img/singleStairs.png",
	"./slideclose.png": "./src/assets/img/slideclose.png",
	"./swain_mb.png": "./src/assets/img/swain_mb.png",
	"./swain_pc.png": "./src/assets/img/swain_pc.png",
	"./template1.jpg": "./src/assets/img/template1.jpg",
	"./template10.jpg": "./src/assets/img/template10.jpg",
	"./template11.jpg": "./src/assets/img/template11.jpg",
	"./template12.jpg": "./src/assets/img/template12.jpg",
	"./template13.jpg": "./src/assets/img/template13.jpg",
	"./template14.jpg": "./src/assets/img/template14.jpg",
	"./template15.jpg": "./src/assets/img/template15.jpg",
	"./template2.jpg": "./src/assets/img/template2.jpg",
	"./template3.jpg": "./src/assets/img/template3.jpg",
	"./template4.jpg": "./src/assets/img/template4.jpg",
	"./template5.jpg": "./src/assets/img/template5.jpg",
	"./template6.jpg": "./src/assets/img/template6.jpg",
	"./template7.jpg": "./src/assets/img/template7.jpg",
	"./template8.jpg": "./src/assets/img/template8.jpg",
	"./template9.jpg": "./src/assets/img/template9.jpg",
	"./templates.png": "./src/assets/img/templates.png",
	"./text-style_1.png": "./src/assets/img/text-style_1.png",
	"./text-style_2.png": "./src/assets/img/text-style_2.png",
	"./text-style_3.png": "./src/assets/img/text-style_3.png",
	"./text-style_4.png": "./src/assets/img/text-style_4.png",
	"./text_curve.png": "./src/assets/img/text_curve.png",
	"./text_shape2.png": "./src/assets/img/text_shape2.png",
	"./text_vertical.png": "./src/assets/img/text_vertical.png",
	"./turf_mb.jpg": "./src/assets/img/turf_mb.jpg",
	"./turf_pc.jpg": "./src/assets/img/turf_pc.jpg",
	"./undo.png": "./src/assets/img/undo.png",
	"./undobk.png": "./src/assets/img/undobk.png",
	"./upimg.jpg": "./src/assets/img/upimg.jpg",
	"./upld-middl-img.jpg": "./src/assets/img/upld-middl-img.jpg",
	"./upmats.jpg": "./src/assets/img/upmats.jpg",
	"./uww.png": "./src/assets/img/uww.png",
	"./wallpad-dialog-box.png": "./src/assets/img/wallpad-dialog-box.png",
	"./wallpad_mb.png": "./src/assets/img/wallpad_mb.png",
	"./wallpad_pc.png": "./src/assets/img/wallpad_pc.png",
	"./wallpaper.png": "./src/assets/img/wallpaper.png",
	"./wrestling_mb.png": "./src/assets/img/wrestling_mb.png",
	"./wrestling_pc.png": "./src/assets/img/wrestling_pc.png",
	"./zoom_minus.png": "./src/assets/img/zoom_minus.png",
	"./zoom_plus.png": "./src/assets/img/zoom_plus.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*$";